import React, { useState } from 'react'
import { api } from '../api'
import { useNavigate } from 'react-router-dom'
import RichTextEditor from "../components/RichTextEditor";

export default function ManufacturerForm() {
  const [manufacturer, setManufacturer] = useState({
    name: '',
    description: '',
    url: ''
  })
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const handleChange = e => {
    const { name, value } = e.target
    setManufacturer({ ...manufacturer, [name]: value })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    try {
      const res = await api.post('/manufacturers', manufacturer)
      navigate(`/manufacturers/${res.data.id}`)
    } catch (err) {
      console.error(err)
      setError('Ошибка при сохранении производителя')
    } finally {
      setSaving(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-gray-900 p-6 rounded-lg text-white">
      <h2 className="text-xl font-semibold mb-2">Добавить производителя</h2>

      {error && <p className="text-red-500">{error}</p>}

 <div className="p-4 bg-gray-800 border-l-4 border-yellow-500 rounded">
               <p className="mb-2 font-semibold text-yellow-500">Обязательное поле</p>
               <div className="space-y-3">
                 <div>
      <div>
        <label className="block mb-1 text-sm text-gray-300">Название</label>
        <input
          type="text"
          name="name"
          value={manufacturer.name}
          onChange={handleChange}
          required
          className="w-full p-2 bg-gray-800 text-white placeholder-gray-400 border border-gray-600 rounded"
        />
      </div>
      </div>
      </div>
      </div>


      <div>
        <label className="block mb-1 text-sm text-gray-300">Описание</label>
        <RichTextEditor
          value={manufacturer.description}
          onChange={(value) =>
            setManufacturer(prev => ({ ...prev, description: value }))
          }
          placeholder="Введите описание или комментарий"
        />

      </div>

      <div>
        <label className="block mb-1 text-sm text-gray-300">Сайт / источник</label>
        <input
          type="text"
          name="url"
          value={manufacturer.url}
          onChange={handleChange}
          className="w-full p-2 bg-gray-800 text-white placeholder-gray-400 border border-gray-600 rounded"
        />
      </div>

      <button
        type="submit"
        disabled={saving}
        className="w-full px-6 py-2 mt-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded disabled:opacity-40"
      >
        {saving ? 'Сохраняем...' : 'Сохранить'}
      </button>
    </form>
  )
}
